import { useRef, useEffect } from "react";
import { useApp } from "../../hooks/AppProvider";

function Log0(props) {
    let app = useApp();    
    let inputRef = useRef(null);

    useEffect(() => {
        if(inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    function changeUsername(e) {
        props.setUsername(e.target.value);
    }

    function next() {
        app.sendPost("/auth/login/0", {username: props.username}, data => {
            if(app.emptyCheck(data.next))
                return props.setStatusMessage("L'utilisateur " + props.username + " n'existe pas");
            
            props.setState(data.next);
        })
    }

    function handleNext(e) {
        if(e.key === "Enter") {
            e.preventDefault();
            next();
        }
    }

    return (
        <>
            <span className="login-label">Nom d'utilisateur</span>
            <input ref={inputRef} value={props.username} onChange={changeUsername} onKeyDown={handleNext} placeholder="Nom d'utilisateur"></input>
            <button onClick={next}>Suivant</button>
        </>
    );
}

export default Log0;